import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, ActionSheetController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoGerenciarVisitantesAddPage } from '../grupo-gerenciar-visitantes-add/grupo-gerenciar-visitantes-add.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImagePipe } from 'src/app/pipes/image/image';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { PessoaProvider } from 'src/app/services/pessoa/pessoa';
import { PessoaMigrarPage } from '../../pessoa/pessoa-migrar/pessoa-migrar.page';
@Component({
  selector: 'app-grupo-gerenciar-visitantes',
  templateUrl: './grupo-gerenciar-visitantes.page.html',
  styleUrls: ['./grupo-gerenciar-visitantes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent,
  ],
})
export class GrupoGerenciarVisitantesPage implements OnInit {
  visitantes: any = [];
  idGrupo: string;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public userProvider: UserProvider,
    public pessoaProvider: PessoaProvider,
  ) {
    this.visitantes = this.navParams.get('visitantes');
    this.idGrupo = this.navParams.get('idGrupo');
  }

  ngOnInit() {
    this.grupoProvider.getVisitantesGrupo(this.idGrupo).subscribe((result) => {
      this.visitantes = result;
    })
  }

  public closeModal() {
    this.modalCtrl.dismiss(this.visitantes);
  }

  async addVisitantes() {
    var data = { idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarVisitantesAddPage, componentProps: data });
    modalPage.present();

    const visitante = (await modalPage.onDidDismiss());
    if (visitante.data) {
      this.visitantes = visitante.data;
    }
  }

  async removerVisitante(visitante: { nome: string; id: string; }) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Confirma Exclusão?'),
      message: this.translate.instant('Excluir') + ' ' + visitante.nome,
      buttons: [
        {
          text: this.translate.instant('Não'),
          handler: () => { }
        },
        {
          text: this.translate.instant('Sim'),
          handler: () => {
            this.grupoProvider.removerVisitante(this.idGrupo, visitante.id).subscribe((data) => {
              this.visitantes.splice(this.visitantes.indexOf(visitante), 1);
            });

          }
        }
      ]
    });
    alert.present();
  }

  async migrar(visitante: any) {
    try {
      const isMigracaoConfigurada = await this.pessoaProvider.buscarMigracaoConfiguracao().toPromise();
      
      if (isMigracaoConfigurada) {
        const modalData = { pessoa: visitante, isVisitante: true, origemGrupos: true };
        const modalPage = await this.modalCtrl.create({component: PessoaMigrarPage, componentProps: modalData});
        await modalPage.present();
        
        const visitantes = (await modalPage.onDidDismiss())
        if (visitantes.data == true) {
          if (modalData) {
            const toast = await this.toastCtrl.create({
              message: this.translate.instant('Migração realizada com sucesso!'),
              duration: 3000
            });

            toast.present();
            this.modalCtrl.dismiss('migracao');
          }
        };
  
      } else {
        this.alertConfig();
      }
    } catch (error) {
      console.error('Erro durante o processo de migração:', error);
      this.alertConfig();
    }
  }

  async alertConfig() {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Atenção!'),
      message: this.translate.instant(
        "Para habilitar essa funcionalidade, é necessário configurar a opção 'Migração de Visitantes' nas configurações do sistema. Aplicativo > Configurações"
      ),
      buttons: [
        {
          text: this.translate.instant('Fechar'),
          role: 'cancel',
        },
      ],
    });

    alert.present();
  }

  async detalhes(visitantes: any) {
    const buttons = [];

    if (this.userProvider.hasConfig(125)) {
      buttons.push({
        text: this.translate.instant('Migrar'),
        handler: async () => {
          this.migrar(visitantes);
        },
      });
    }

    if (this.userProvider.hasConfig(121)) {
      buttons.push({
        text: this.translate.instant('Remover'),
        handler: () => {
          this.removerVisitante(visitantes);
        },
      });
    }

    buttons.push({
      text: this.translate.instant('Fechar'),
      role: 'destructive',
    });

    if (buttons.length > 0) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        buttons,
      });

      await actionSheet.present();
    }
  }
}
